import { Chip } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { capitalize } from 'lodash'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import NoRecords from 'components/NoRecords'
import formatAddress from 'utils/formatAddress'
import { visibleProofList } from 'utils/proofOfAddress'
import { ADDRESS_CHANGE_STATUS_COLORS } from 'constants'

export const fullName = person => (person ? `${person.firstName} ${person.lastName}` : '')

export default function AddressChangeList({ rows, onSelect }) {
  const { t } = useTranslation()

  const columns = [
    {
      field: 'primaryParent',
      headerName: t('Requested By'),
      flex: 1,
      minWidth: 160,
      valueGetter: (value, row) => fullName(row.primaryParent),
    },
    {
      field: 'students',
      headerName: t('Students'),
      flex: 1.5,
      minWidth: 180,
      valueGetter: (value, row) => (row.students ?? []).map(fullName).join(', '),
    },
    {
      field: 'address',
      headerName: t('New Address'),
      flex: 1,
      minWidth: 220,
      valueGetter: (value, row) => formatAddress(row.address) ?? '',
    },
    {
      field: 'proofOfAddress',
      headerName: t('Files'),
      flex: 1,
      sortable: false,
      valueGetter: value => visibleProofList(value).length,
    },
    {
      field: 'createdAt',
      headerName: t('Submitted'),
      flex: 1,
      valueFormatter: value => (value ? dayjs(value).format('MM/DD/YYYY') : ''),
    },
    {
      field: 'status',
      headerName: t('Status'),
      flex: 1,
      renderCell: ({ value }) => (
        <Chip label={t(capitalize(value))} color={ADDRESS_CHANGE_STATUS_COLORS[value]} size="small" />
      ),
    },
  ]

  return (
    <DataGrid
      rows={rows ?? []}
      columns={columns}
      getRowId={row => row.id}
      hideFooter
      disableColumnMenu
      loading={!rows}
      rowHeight={56}
      onRowClick={({ row }) => onSelect(row)}
      slots={{ noRowsOverlay: NoRecords }}
      sx={{
        height: 'calc(100vh - 280px)',
        cursor: 'pointer',
        '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' },
      }}
    />
  )
}
